'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { authBunja } from '@flipster/features/src/shared/auth/state';

import { authRedirectBunja } from './bunja';

const AuthRedirect = () => {
  const { isCookieLoggedInAtom } = useBunja(authBunja);
  const isCookieLoggedIn = useAtomValue(isCookieLoggedInAtom);
  const { setReferrerPath, gotoLoginPage, gotoAfterLoginPage, gotoReferralPage, gotoAffiliatePage } =
    useBunja(authRedirectBunja);

  // 페이지당 한 번만 불려야 함 (strict mode 때문에 두 번 불리는 경우 제외)
  useEffect(() => {
    setReferrerPath();
    gotoReferralPage();
    gotoAffiliatePage();
  }, [setReferrerPath, gotoReferralPage, gotoAffiliatePage]);

  // `isCookieLoggedIn`이 변경되면 같은 페이지 안에서 다시 불릴 수 있음
  useEffect(() => {
    gotoLoginPage();
    gotoAfterLoginPage();
  }, [isCookieLoggedIn, gotoLoginPage, gotoAfterLoginPage]);

  return null;
};

export default AuthRedirect;
